(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whalebud-pet-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whalebud-pet-reviews-carousel')) {
    customElements.define('whalebud-pet-reviews-carousel', class extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.handleClick);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.initializeAttempts = 0;
        this.initialize();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.clearTimeout(this.initializeTimer);
        if (this.swiper) this.swiper.destroy(true, true);
      }

      initialize() {
        if (!window.Swiper) {
          if (this.initializeAttempts < 40) {
            this.initializeAttempts += 1;
            this.initializeTimer = window.setTimeout(() => this.initialize(), 100);
          }
          return;
        }

        const viewport = this.querySelector('.whalebud-pet-reviews__viewport');
        if (!viewport || viewport.swiper) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const slideCount = Number(this.dataset.whalebudSlideCount || 0);
        const autoplayEnabled = this.dataset.whalebudAutoplay === 'true' && !reduceMotion && slideCount > 1;

        this.swiper = new window.Swiper(viewport, {
          slidesPerView: Number(this.dataset.whalebudSlidesM || 1.08),
          spaceBetween: Number(this.dataset.whalebudGapM || 12),
          watchOverflow: true,
          allowTouchMove: slideCount > 1,
          loop: this.dataset.whalebudLoop === 'true' && slideCount > Number(this.dataset.whalebudSlidesPc || 4),
          speed: reduceMotion ? 0 : 350,
          autoplay: autoplayEnabled ? {
            delay: Number(this.dataset.whalebudAutoplayDelay || 5000),
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          } : false,
          navigation: {
            nextEl: this.querySelector('.whalebud-pet-reviews__arrow--next'),
            prevEl: this.querySelector('.whalebud-pet-reviews__arrow--previous')
          },
          breakpoints: {
            750: {
              slidesPerView: Number(this.dataset.whalebudSlidesPad || 2),
              spaceBetween: Number(this.dataset.whalebudGapPad || 16)
            },
            990: {
              slidesPerView: Number(this.dataset.whalebudSlidesPc || 4),
              spaceBetween: Number(this.dataset.whalebudGapPc || 20)
            }
          }
        });

        if (reduceMotion) {
          this.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
        }
      }

      handleBlockSelect(event) {
        const item = event.target.closest('[data-whalebud-block-id]');
        if (!item || !this.contains(item) || !this.swiper) return;
        const slides = Array.from(this.querySelectorAll('[data-whalebud-block-id]'));
        const index = slides.indexOf(item);
        if (index < 0) return;
        if (this.swiper.params.loop && this.swiper.slideToLoop) {
          this.swiper.slideToLoop(index, 0);
        } else {
          this.swiper.slideTo(index, 0);
        }
      }

      handleClick(event) {
        const button = event.target.closest('[data-whalebud-youtube-pc], [data-whalebud-youtube-m]');
        if (!button || !this.contains(button)) return;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const videoId = (mobile ? button.dataset.whalebudYoutubeM : button.dataset.whalebudYoutubePc) || button.dataset.whalebudYoutubePc || button.dataset.whalebudYoutubeM;
        if (!videoId) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
        iframe.title = button.dataset.whalebudYoutubeTitle || 'Customer review video';
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        button.replaceWith(iframe);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
